import React from 'react';

import {
  PublicationCommonErrorItem,
  PublicationErrorItemValidationRule,
} from './PublicationErrorItem';

const PublicationCommonErrorList = (props) => {
  const {
    errorGroup,
    groupIdx,
    status,
    setErrorIndex,
    setProductId,
    toggleCheckErrorModal,
    productEnums,
    productSchema,
    productDetailList,
    productModuleList,
  } = props;
  return (
    <>
      {errorGroup?.errorFields.map((errorItem, itemIdx) => {
        const isErrorItem = !!errorItem?.productId;

        const errorInfo = {
          errorProductId: errorItem?.productId,
          errorType: errorGroup?.errorType,
          errorMessage: errorGroup?.errorMessage,
          moduleName: errorItem?.moduleName,
          fieldName: errorItem?.fieldName,
        };

        const itemErrorKey = `${groupIdx}-${itemIdx}`;

        const splitFieldNames = errorItem?.fieldName.split('.');

        const isNonNestedField = errorItem.fieldName.split('.').length === 1;

        /* Currently, BE hasn't support completely yet */
        if (
          errorItem?.moduleName === 'ProductItem' &&
          splitFieldNames?.[0]?.toLowerCase() !== 'header'
        ) {
          return (
            <PublicationErrorItemValidationRule
              productItemId={errorItem?.productId}
            />
          );
        }

        /* We need to map */
        if (
          errorItem?.moduleName &&
          errorItem?.moduleName !== 'ProductItem' &&
          isNonNestedField
        ) {
          const newErrorItem = {
            ...errorItem,
            fieldName: `${errorItem?.fieldName}.${errorItem?.fieldName}`,
          };

          return (
            <PublicationCommonErrorItem
              key={itemErrorKey}
              errorItem={newErrorItem}
              isErrorItem={isErrorItem}
              isRivirField={false}
              status={status}
              setErrorIndex={setErrorIndex}
              setProductId={setProductId}
              toggleCheckErrorModal={toggleCheckErrorModal}
              productEnums={productEnums}
              productSchema={productSchema}
              errorInfo={errorInfo}
              groupIdx={groupIdx}
              itemIdx={itemIdx}
              productDetailList={productDetailList}
              productModuleList={productModuleList}
            />
          );
        }

        return (
          <PublicationCommonErrorItem
            key={itemErrorKey}
            errorItem={errorItem}
            isErrorItem={isErrorItem}
            isRivirField={isNonNestedField}
            status={status}
            setErrorIndex={setErrorIndex}
            setProductId={setProductId}
            toggleCheckErrorModal={toggleCheckErrorModal}
            productEnums={productEnums}
            productSchema={productSchema}
            errorInfo={errorInfo}
            groupIdx={groupIdx}
            itemIdx={itemIdx}
            productDetailList={productDetailList}
            productModuleList={productModuleList}
          />
        );
      })}
    </>
  );
};

export default PublicationCommonErrorList;
